import React, { useState } from "react";
import styles from "../styles/patient-page-modules/PatientDocuments.module.css";
import DatePicker from "../components/shared-modules/DatePicker/DatePicker";
import { formatDate } from "../utils/helper";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../components/ui/popover";
import { toast } from "react-hot-toast";
const DateRangeSelector = ({ onDateChange }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleStartDateChange = (value) => {
    if (endDate && value > endDate) {
      setEndDate(value);
    }
    setStartDate(value);
    onDateChange({ start: value, end: endDate });
  };

  const handleEndDateChange = (value) => {
    if (startDate && value < startDate) {
      toast.error("End date cannot be before start date");
      return;
    }
    setEndDate(value);
    onDateChange({ start: startDate, end: value });
  };

  return (
    <div className={styles.date_range_cont}>
      <DatePicker
        onCancelSelect={() => setStartDate(new Date())}
        onDateSelect={handleStartDateChange}
        selectedDate={startDate}
        className={styles.input}
      />
      <p>to</p>

      <DatePicker
        onCancelSelect={() => setEndDate(new Date())}
        onDateSelect={handleEndDateChange}
        selectedDate={endDate}
        className={styles.input}
      />

      {/* <input
        type="date"
        value={endDate}
        onChange={handleEndDateChange}
        min={startDate}
      /> */}
    </div>
  );
};

export default DateRangeSelector;
